<template>
    <card :header-content-class="['w-100']">
        <template #header-icon>
            <font-awesome-icon :icon="['fas', 'address-card']" size="lg" />
        </template>
        <template #header-content> Guest Details </template>
        <template #body>
            <div v-if="client">
                <div id="lx-online-booking-checkout-client-details" class="lx-online-booking-checkout-client-details">
                    <b-row>
                        <b-col md="3">
                            <form-select
                                v-model="client.title_id"
                                floating-label="Title"
                                :leftIcon="['fas', 'user']"
                                :options="client.titles_options"
                            />
                        </b-col>
                        <b-col md="3">
                            <validation-provider
                                name="s2_02_first_name"
                                v-slot="{ errors, handleChange }"
                                rules="required"
                                
                                :value="client.first_name"
                            >
                                <form-input
                                    name="s2_02_first_name"
                                    autocomplete="given-name"
                                    v-model="client.first_name"
                                    floating-label="First name"
                                    :leftIcon="['fas', 'user']"
                                    @change="requireNewSignature()"
                                    :error="errors[0]"
                                    @input="handleChange"
                                />
                            </validation-provider>
                        </b-col>
                        <b-col md="6">
                            <validation-provider
                                name="s2_03_last_name"
                                v-slot="{ errors, handleChange }"
                                rules="required"
                                
                                :value="client.last_name"
                            >
                                <form-input
                                    name="s2_03_last_name"
                                    autocomplete="family-name"
                                    v-model="client.last_name"
                                    floating-label="Last name"
                                    :leftIcon="['fas', 'user']"
                                    @change="requireNewSignature()"
                                    :error="errors[0]"
                                    @input="handleChange"
                                />
                            </validation-provider>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col md="6">
                            <validation-provider
                                name="s2_04_email"
                                v-slot="{ errors, handleChange }"
                                rules="required|email|confirmedEmail:@s2_05_email_confirm"
                                
                                :value="client.email"
                            >
                                <form-input
                                    name="s2_04_email"
                                    v-model="client.email"
                                    :leftIcon="['fas', 'at']"
                                    floatingLabel="Email"
                                    :error="errors[0]"
                                    @input="handleChange"
                                ></form-input>
                            </validation-provider>
                        </b-col>
                        <b-col md="6">
                            <validation-provider
                                name="s2_05_email_confirm"
                                v-slot="{ errors, handleChange }"
                                rules="required|email|confirmedEmail:@s2_04_email"
                                
                                :value="client.email_confirm"
                            >
                                <form-input
                                    name="s2_05_email_confirm"
                                    v-model="client.email_confirm"
                                    :leftIcon="['fas', 'at']"
                                    floatingLabel="Confirm Email"
                                    :error="errors[0]"
                                    @input="handleChange"
                                ></form-input>
                            </validation-provider>
                        </b-col>
                    </b-row>
                    <b-row v-if="showDateOfBirth && minimumRentingAge > 0">
                        <b-col md="6">
                            <validation-provider
                                name="s2_00_date_of_birth"
                                v-slot="{ errors, handleChange }"
                                rules="required"
                                
                                :value="client.date_of_birth"
                            >
                                <form-datepicker
                                    name="s2_00_date_of_birth"
                                    v-model="client.date_of_birth"
                                    floating-label="Date of birth"
                                    :initial-date="minDateOfBirth"
                                    :description="`Minimum age for primary renter is ${minimumRentingAge} years old.`"
                                    :min="maxDateOfBirth"
                                    :max="minDateOfBirth"
                                    :hide-header="true"
                                    :display-format="userUnicodeDateFormat"
                                    :error="errors[0]"
                                    @input="handleChange"
                                ></form-datepicker>
                            </validation-provider>
                        </b-col>
                    </b-row>
                    <card class="mt-2" :nested="true">
                        <template #header-icon>
                            <font-awesome-icon :icon="['fas', 'address-book']" size="lg" />
                        </template>
                        <template #header-content> Billing Address </template>
                        <template #body>
                            <b-row>
                                <b-col md="6">
                                    <validation-provider
                                        name="s2_06_address1"
                                        v-slot="{ errors, handleChange }"
                                        rules="required"
                                        
                                        :value="client.address1"
                                    >
                                        <form-input
                                            name="s2_06_address1"
                                            autocomplete="address-line1"
                                            v-model="client.address1"
                                            floating-label="Address line 1"
                                            :left-icon="['fas', 'location-dot']"
                                            @change="requireNewSignature()"
                                            :error="errors[0]"
                                            @input="handleChange"
                                        ></form-input>
                                    </validation-provider>
                                </b-col>
                                <b-col md="6">
                                    <form-input
                                        name="address-line2"
                                        autocomplete="address-line2"
                                        v-model="client.address2"
                                        floating-label="Address line 2"
                                        :left-icon="['fas', 'location-dot']"
                                        @change="requireNewSignature()"
                                    ></form-input>
                                </b-col>
                            </b-row>
                            <b-row>
                                <b-col md="6">
                                    <validation-provider
                                        name="s2_08_country"
                                        v-slot="{ errors, handleChange }"
                                        rules="required"
                                        
                                        :value="client.country_id"
                                    >
                                        <form-select
                                            name="s2_08_country"
                                            autocomplete="country"
                                            v-model="client.country_id"
                                            floating-label="Country"
                                            :left-icon="['fas', 'location-dot']"
                                            @change="onChangeCountry"
                                            :options="countries"
                                            :error="errors[0]"
                                            @input="handleChange"
                                        ></form-select>
                                    </validation-provider>
                                </b-col>
                                <b-col md="6">
                                    <validation-provider
                                        name="s2_09_zip"
                                        v-slot="{ errors, handleChange }"
                                        rules="required"
                                        
                                        :value="client.zip"
                                    >
                                        <form-input
                                            name="s2_09_zip"
                                            autocomplete="postal-code"
                                            v-model="client.zip"
                                            floating-label="Zip / Postal code"
                                            :left-icon="loading ? undefined : ['fas', 'location-dot']"
                                            :left-button="loading"
                                            :error="errors[0]"
                                            @input="(val) => {
                                                 handleZipChange(val)
                                                 handleChange(val)
                                            }"
                                        >
                                            <template #leftButton v-if="loading">
                                                <b-spinner small></b-spinner>
                                            </template>
                                        </form-input>
                                    </validation-provider>
                                </b-col>
                            </b-row>
                            <b-row>
                                <b-col md="6">
                                    <validation-provider
                                        name="s2_10_city"
                                        v-slot="{ errors, handleChange }"
                                        rules="required"
                                        :value="client.city"
                                        ref="city_input"
                                    >
                                        <form-input
                                            name="s2_10_city"
                                            autocomplete="address-level2"
                                            v-model="client.city"
                                            floating-label="City"
                                            :left-icon="loading ? undefined : ['fas', 'location-dot']"
                                            :left-button="loading"
                                            :error="errors[0]"
                                            @change="requireNewSignature()"
                                            @input="handleChange"
                                        >
                                            <template #leftButton v-if="loading">
                                                <b-spinner small></b-spinner>
                                            </template>
                                        </form-input>
                                    </validation-provider>
                                </b-col>
                                <b-col md="6">
                                    <validation-provider
                                        name="s2_11_state"
                                        v-slot="{ errors, handleChange }"
                                        rules="required"
                                        ref="state_input"
                                        :value="client.state_id"
                                    >
                                        <form-select
                                            name="s2_11_state"
                                            autocomplete="address-level1"
                                            v-model="client.state_id"
                                            floating-label="State / Region"
                                            :left-icon="loading ? undefined : ['fas', 'location-dot']"
                                            :left-button="loading"
                                            :error="errors[0]"
                                            :options="statesOptions"
                                            @change="requireNewSignature()"
                                            @input="handleChange"
                                        >
                                            <template #leftButton v-if="loading">
                                                <b-spinner small></b-spinner>
                                            </template>
                                        </form-select>
                                    </validation-provider>
                                </b-col>
                            </b-row>
                        </template>
                    </card>
                    <card class="mt-2" :nested="true" v-if="showMiscellaneous">
                        <template #header-icon>
                            <font-awesome-icon :icon="['fas', 'circle-info']" size="lg" />
                        </template>
                        <template #header-content> Miscellaneous </template>
                        <template #body>
                            <b-row>
                                <b-col>
                                    <validation-provider
                                        ref="mobilePhone"
                                        name="s2_12_mobile_phone"
                                        v-slot="{ errors, handleChange }"
                                        rules="required|validPhoneNumber"
                                    >
                                        <form-phone-number-input
                                            v-model="client.mobile_phone"
                                            inputId="online-booking-checkout-client-details-mobile-phone"
                                            floating-label="Mobile"
                                            @change="requireNewSignature()"
                                            :default-country-code="defaultCountryCode"
                                            :error="errors[0]"
                                            @validate="onValidatePhone"
                                            @input="handleChange"
                                            name="s2_12_mobile_phone"
                                        />
                                    </validation-provider>
                                    <span v-if="displaySMSOptin">
                                        <form-checkbox v-model="client.allow_sms" >
                                            Text me reservation details and payment reminders
                                        </form-checkbox>
                                        <p>
                                            By checking this option, you agree to receive mobile messages at the phone
                                            number provided. Message frequency varies. Message and data rates may apply.
                                            View our <a target="_blank" href="/privacy-policy/">Privacy Policy</a> and
                                            <a target="_blank" href="/terms-of-service/">Terms of Service</a>
                                        </p>
                                        <br />
                                    </span>
                                </b-col>
                            </b-row>
                            <b-row>
                                <b-col>
                                    <validation-provider
                                        name="s2_13_description"
                                        v-slot="{ errors, handleChange }"
                                        :rules="isMessageFieldRequired"
                                        
                                        :value="client.notes"
                                    >
                                        <form-textarea
                                            name="s2_13_description"
                                            v-model="client.notes"
                                            :floatingLabel="website.message_field_label"
                                            :error="errors[0]"
                                            :rows="4"
                                            @input="handleChange"
                                        />
                                    </validation-provider>
                                </b-col>
                            </b-row>
                            <b-row v-if="customFieldDisplayOnline">
                                <b-col>
                                    <validation-provider
                                        :name="client.custom_field.title"
                                        v-slot="{ errors, handleChange }"
                                        rules="required|minusOneThrowsRequired"
                                        
                                        :value="client.custom_field_index"
                                    >
                                        <form-select
                                            class="mb-0"
                                            v-model="client.custom_field_index"
                                            :floating-label="client.custom_field.title"
                                            :options="customFieldOptions"
                                            :error="errors[0]"
                                            @input="handleChange"
                                            :name="client.custom_field.title"
                                        ></form-select>
                                    </validation-provider>
                                    <span
                                        v-if="client.custom_field.description"
                                        class="mt-1 mb-3 text-muted lx-online-booking-checkout-client-details__subtitles"
                                    >
                                        {{ client.custom_field.description }}
                                    </span>
                                </b-col>
                            </b-row>
                            <b-row class="mt-2" v-for="variable in client.invoice_variables" :key="variable.id">
                                <b-col>
                                    <validation-provider
                                        v-if="
                                            (!variable.input_type || variable.input_type == 'text') &&
                                            variable.rows <= 1
                                        "
                                        :name="'s2_' + variable.name"
                                        v-slot="{ errors, handleChange }"
                                        :rules="variable.is_compulsory_at_booking ? 'required' : ''"
                                        
                                        :value="variable.value"
                                    >
                                        <form-input
                                            :label="variable.title.length > 30 ? variable.title : undefined"
                                            :floatingLabel="variable.title.length > 30 ? undefined : variable.title"
                                            v-model="variable.value"
                                            :error="errors[0]"
                                            @input="handleChange"
                                            :name="'s2_' + variable.name"
                                        ></form-input>
                                    </validation-provider>
                                    <validation-provider
                                        v-if="
                                            (!variable.input_type || variable.input_type == 'text') && variable.rows > 1
                                        "
                                        :name="'s2_' + variable.name"
                                        v-slot="{ errors, handleChange }"
                                        :rules="variable.is_compulsory_at_booking ? 'required' : ''"
                                        
                                        :value="variable.value"
                                    >
                                        <form-textarea
                                            :label="variable.title.length > 30 ? variable.title : undefined"
                                            :floatingLabel="variable.title.length > 30 ? undefined : variable.title"
                                            v-model="variable.value"
                                            :error="errors[0]"
                                            :rows="variable.rows"
                                            @input="handleChange"
                                            :name="'s2_' + variable.name"
                                        />
                                    </validation-provider>
                                    <validation-provider
                                        v-if="variable.input_type == 'date'"
                                        :name="'s2_' + variable.name"
                                        v-slot="{ errors, handleChange }"
                                        :rules="variable.is_compulsory_at_booking ? 'required' : ''"
                                        
                                        :value="variable.value"
                                    >
                                        <form-datepicker
                                            :label="variable.title.length > 30 ? variable.title : undefined"
                                            :floatingLabel="variable.title.length > 30 ? undefined : variable.title"
                                            :hide-header="true"
                                            v-model="variable.value"
                                            :display-format="userUnicodeDateFormat"
                                            :error="errors[0]"
                                            @input="handleChange"
                                            :name="'s2_' + variable.name"
                                        ></form-datepicker>
                                    </validation-provider>
                                </b-col>
                            </b-row>
                        </template>
                    </card>
                    <card
                        :nested="true"
                        v-if="client.invoice_variables_form && client.invoice_variables_form.show_on_booking"
                        class="mt-2"
                    >
                        <template #header-icon>
                            <font-awesome-icon :icon="['fas', 'circle-info']" size="lg" />
                        </template>
                        <template #header-content> {{ client.invoice_variables_form.title }} </template>
                        <template #body>
                            <b-row>
                                <b-col>
                                    <form-generator
                                        ref="form_generator"
                                        class="modal-form-generator"
                                        :results="{}"
                                        :surveyJSON="surveyJSON"
                                        @onValueChanged="onUpdateSurveyData"
                                        @ready="(survey) => onUpdateSurveyData({ survey })"
                                        :primaryColor="cssVariables.primary_background_color"
                                    />
                                </b-col>
                            </b-row>
                        </template>
                    </card>
                </div>
            </div>
            <div v-else></div>
        </template>
    </card>
</template>

<script>
import { mapGetters } from 'vuex';
import API from '../../../../api.jsx';
import debounce from 'lodash/debounce';
import subYears from 'date-fns/subYears';
import { parsePhoneNumber } from 'awesome-phonenumber';
import Card from '../../../generic/card/card.vue';
import FormInput from '../../../generic/form-input/form-input.vue';
import FormSelect from '../../../generic/form-select/form-select.vue';
import FormTextarea from '../../../generic/form-textarea/form-textarea.vue';
import FormDatepicker from '../../../generic/form-datepicker/form-datepicker.vue';
import FormCheckbox from '../../../generic/form-checkbox/form-checkbox.vue';
import { prepareSurveyDataToSend } from '../../../hosted-form/hosted-form-page.vue';
import { defineAsyncComponent } from 'vue';

const FormGenerator = defineAsyncComponent(() =>
    import(
        /* webpackChunkName: "lx-form-generator" */
        '../../../hosted-form/form-generator.vue'
    )
);

const FormPhoneNumberInput = defineAsyncComponent(() =>
    import(
        /* webpackChunkName: "lx-form-phone-number-input" */
        '../../../generic/form-phone-number-input/form-phone-number-input.vue'
    )
);

export default {
    name: 'OnlineBookingCheckoutClientDetails',
    components: {
        Card,
        FormInput,
        FormSelect,
        FormCheckbox,
        FormTextarea,
        FormDatepicker,
        FormPhoneNumberInput,
        FormGenerator,
    },
    props: {
        showDateOfBirth: {
            type: Boolean,
            default: true,
        },
        showMiscellaneous: {
            type: Boolean,
            default: true,
        },
    },
    mounted() {
        (async () => {
            this.loading = true;
            try {
                await Promise.all([this.fetchCountries(), this.fetchStates(this.client.country_id)]);
            } finally {
                this.loading = false;
            }
        })();
    },
    computed: {
        ...mapGetters('onlineBooking', ['client', 'website', 'reservation', 'countries', 'states', 'cssVariables']),
        ...mapGetters('header', ['userUnicodeDateFormat']),
        minDateOfBirth() {
            return subYears(new Date(), this.minimumRentingAge);
        },
        maxDateOfBirth() {
            return subYears(new Date(), 150);
        },
        minimumRentingAge() {
            let minimumRentingAge = 0;
            this.reservation.tech_reservations.forEach((i) => {
                minimumRentingAge = Math.max(minimumRentingAge, i.property.minimum_renting_age || 0);
            });
            return minimumRentingAge;
        },
        defaultCountryCode() {
            if (this.client.mobile_phone) {
                const phone = parsePhoneNumber(this.client.mobile_phone);
                return phone.g.regionCode;
            } else {
                return this.$store.getters['account/code'];
            }
        },
        isMessageFieldRequired() {
            return this.website.is_message_field_required ? 'required' : '';
        },
        customFieldDisplayOnline() {
            return this.client?.custom_field?.display_online;
        },
        customFieldOptions() {
            if (this.customFieldDisplayOnline) {
                return [{ value: -1, text: 'Please select ...', disabled: true }].concat(
                    this.client.custom_field_choices.map((choice) => ({
                        value: choice.id,
                        text: choice.title,
                    }))
                );
            }
            return [];
        },
        statesOptions() {
            return [{ value: null, text: 'Not set' }, ...this.states];
        },
        surveyJSON() {
            if (this.client.invoice_variables_form) {
                const json = JSON.parse(JSON.stringify(this.client.invoice_variables_form.form_json));
                json.title = ' ';
                json.showNavigationButtons = false;
                json.elements = json.elements.map((item) => ({
                    ...item,
                    visible: item.showOnBooking,
                }));
                return JSON.stringify(json);
            }
            return '';
        },
        displaySMSOptin() {
            return this.website.display_sms_optin;
        },
    },
    data() {
        return {
            loading: false,
        };
    },
    methods: {
        async fetchCountries() {
            try {
                await this.$store.dispatch('onlineBooking/fetchCountries');
            } catch (e) {
                this.errorToast({
                    text: `Could not load countries.`,
                });
            }
        },
        async fetchStates(value) {
            try {
                await this.$store.dispatch('onlineBooking/fetchStates', {
                    countryId: value,
                });
                let found = false;
                for (let state of this.states) {
                    if (state.value == this.client.state_id) {
                        found = true;
                        break;
                    }
                }
                if (!found) this.client.state_id = null;
            } catch (e) {
                this.errorToast({ text: 'Could not load states.' });
            }
        },
        handleZipChange: debounce(async function (zip) {
            if (!this.client || !this.client.country_id || zip.length < 5) return;

            this.loading = true;
            try {
                const { data } = await API.get(`/asynchronous/ziptastic/${this.client.country_id}/${zip}`);
                if (!data || data.message === 'Not Found') throw new Error();
                this.client.city = data.city;
                this.$refs.city_input.setValue(data.city);
                this.states.forEach((state) => {
                    if (state.code === data.state_short) {
                        this.client.state_id = state.value;
                        this.$refs.state_input.setValue(state.value);
                    };
                });
            } catch (err) {
                this.warningToast({
                    text: 'Unable to auto fill city and state.',
                });
            } finally {
                this.loading = false;
            }
        }, 500),
        async onChangeCountry() {
            const currentCountry = this.countries.find((item) => item.value === this.client.country_id);
            this.$store.dispatch('account/changeCountryCode', currentCountry.code);
        },
        onValidatePhone(value) {
            this.$refs.mobilePhone.validate();
            if (value.isValid) {
                this.client.mobile_phone = value.number.e164;
            }
        },
        requireNewSignature() {
            this.client.is_signed = false;
        },
        setHostedFormErrors(survey) {
            const errors = survey
                .getAllQuestions()
                .filter((item) => !!item.errors.length)
                .map((item) => {
                    return {
                        name: item.fullTitle,
                        id: item.id,
                    };
                });
            this.client.invoice_variables_form_errors = errors;
            this.$store.commit('onlineBooking/setInvoiceVariablesFormErrors', errors);
        },
        onUpdateSurveyData({ survey }) {
            survey.validate();
            this.$nextTick(() => {
                const results = prepareSurveyDataToSend(survey, this.surveyJSON);
                this.$store.commit('onlineBooking/setInvoiceVariablesFormResults', results);
                this.setHostedFormErrors(survey);
            });
        },
    },
    watch: {
        'client.country_id': function (countryID, previousCountryID) {
            if (countryID !== previousCountryID && countryID !== undefined) {
                this.fetchStates(countryID);
            }
        },
    },
};
</script>

<style lang="scss" scoped>
@import '~bootstrap/scss/_functions.scss';
@import '~bootstrap/scss/_variables.scss';
@import '~bootstrap/scss/mixins/_breakpoints.scss';
@import '../../../hosted-form/styles.scss';

#lx-online-booking-checkout-client-details .lx-online-booking-checkout-client-details {
    &__subtitles {
        display: inline-block;
        font-size: 12px;
        line-height: 120%;
    }

    &__date-of-birth-message {
        padding-top: 9px;
        color: grey;
    }
}
</style>
